<div *ngIf="pageModel$ | async as pageModel" class="pcg-search-page pcg-search-page--info pcg-contrast__bg-alt">
    <div class="pcg-search-page__row container">
        <pcg-ng-saved-searches-bar [savedSearchesPageLink]="pageModel.properties.SavedSearchesPage" data-config="{}"></pcg-ng-saved-searches-bar>

        <a *ngIf="pageModel.properties.ToolbarButton?.length" [link]="pageModel.properties.ToolbarButton" class="pcg-main-button pcg-contrast__btn" pcg-ng-umbraco-link></a>
    </div>
    <div class="container pcg-search-page__mainbar">
        <ng-container *ngIf="isLocked$ | async">
            <div class="pcg-backdrop"></div>
            <div class="pcg-spinner pcg-spinner--large"></div>
        </ng-container>

        <ng-container *ngIf="searchResult$ | async as searchResultModel">
            <div class="pcg-search-toolbar">
                    <div *ngIf="!searchResultModel.pageItems?.length"
                         [innerHTML]="resolveNoResultsMessage(pageModel.properties.SearchNoResultsMessage?.markup)"
                         class="pcg-search-toolbar__no-results pcg-contrast__color-main"
                         role="status">
                    </div>

                <div *ngIf="searchResultModel.pageItems?.length" class="pcg-search-toolbar__row">
                    <p class="pcg-search-toolbar__results pcg-contrast__color-main"
                       role="status">{{ searchResultModel.totalItems }} results found</p>

                    <div class="pcg-search-sorting pcg-contrast-search-sorting pcg-search-toolbar__sorting">
                        <label class="pcg-search-sorting__label" for="search-sorting">Sort by:</label>
                        <div class="pcg-search-sorting__wrapper">
                            <select (ngModelChange)="setSorting($event)"
                                    [(ngModel)]="selectedSorting" class="pcg-search-sorting__select" id="search-sorting"
                                    name="">
                                <option value="Rank;asc">Relevance</option>
                                <option value="Name;asc">A-Z</option>
                                <option value="Name;desc">Z-A</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="searchResultModel.pageItems?.length">
                <pcg-ng-pagination
                    (ngModelChange)="setPageNumber($event)"
                    [(ngModel)]="selectedPageNumber"
                    [options]="paginationOptions"
                    [pagination]="searchResultModel"
                    [parentSelector]="'pcg-search-page__pagination'"
                    class="pcg-search-page__pagination">
                </pcg-ng-pagination>
                <pcg-ng-content-search-results-list-view
                    [searchResult]="searchResultModel">
                </pcg-ng-content-search-results-list-view>
                <pcg-ng-pagination
                    (ngModelChange)="setPageNumber($event)"
                    [(ngModel)]="selectedPageNumber"
                    [options]="paginationOptions"
                    [pagination]="searchResultModel"
                    [parentSelector]="'pcg-search-page__pagination'"
                    class="pcg-search-page__pagination">
                </pcg-ng-pagination>
            </ng-container>
        </ng-container>
    </div>
</div>
